import './TeamCollected.scss'

import React from 'react'
import {Theme} from '../../Theme'
import {number_format} from '../../../util/price'
import {style} from '../../../util/style'
import {useTranslation} from '../../../util/i18n'

const styles = style('teamcollected')

export type TeamCollectedType = {
	className?: string
	price: number
	title?: string
	exportUrl: string
}

export const TeamCollected: React.FC<TeamCollectedType> = ({
	className,
	price,
	title,
	exportUrl
}) => {
	const t = useTranslation().teams.detail.collected
	if (price === null) return null

	return (
		<div className={styles().with(className)}>
			<h5 className={styles('title')}>{title || t.title}</h5>
			<div className={styles('text')}>
				<Theme.Wysiwyg>
					{t.text.replace('{{price}}', `${number_format(price, 2, ',', '.')}`)}
				</Theme.Wysiwyg>
			</div>
			<div className={styles('button')}>
				<Theme.Button to={exportUrl} target="_blank" mod={['whitebg']}>
					{t.btnlabel}
				</Theme.Button>
			</div>
		</div>
	)
}
